module.exports = {
      id: "tiktok-square-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "svg-sprite-e76c2ea32079628f8a8c5156f1fd5f59.svg#tiktok-square",
      toString: function () {
        return this.url;
      }
    }